var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistory = function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7h1.5v6.5H8V12h4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12c0-4.968 4.032-9 9-9s9 4.032 9 9-4.032 9-9 9-9-4.032-9-9m1.8 0c0 3.969 3.231 7.2 7.2 7.2s7.2-3.231 7.2-7.2-3.231-7.2-7.2-7.2S4.8 8.031 4.8 12"
  })));
};
export default SvgHistory;